export default {
    // récuperer toutes les guichets dans la base de données 
    get_auth_guichets(tokens){

        return axios.get('/authuserguichet', {
            headers: {
                Authorization: "Bearer " + tokens
            }
        }) 
    },
    get_all_atms(){
        return axios.get('/guichets', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_atms_own(serverParams){
        return axios.post('/guichet/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    guichet_active(serverParams){
        return axios.get('/guichet/getactive',{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_atms_by_agency(serverParams){
        return axios.post('/guichets/agence/' + serverParams.agence_id + '?page='+ serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les guichets dans la base de données 
    post_guichets(guichet){
        return axios.post('/guichets',guichet, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_guichets(id,guichet){
        return axios.put('/guichets/'+id,guichet, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_guichets(id){
        return axios.get('/guichets/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_guichets(id){
        return axios.get('/desactive/guichet/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    active_guichets(id){
        return axios.get('/active/guichet/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}